export default __webpack_public_path__ + "static/media/minus.05dd87ea.svg";